import { render, staticRenderFns } from "./task-list.vue?vue&type=template&id=1494a14d&"
import script from "./task-list.vue?vue&type=script&lang=js&"
export * from "./task-list.vue?vue&type=script&lang=js&"
import style0 from "./task-list.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports